import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { PreviewEventWithMetadata } from "../screens/case/utils/types";

// Combined data for preview cases
export type PreviewCaseData = {
  events: PreviewEventWithMetadata[]; // Events with their associated metadata
};

interface StoreState {
  previewDataByKey: Record<string, PreviewCaseData>;
}

const initialState: StoreState = {
  previewDataByKey: {},
};

export type Action = {
  setPreviewData: (key: string, data: PreviewCaseData) => void;
  clearPreviewData: (key: string) => void;
  clearAllPreviewData: () => void;
  reset: () => void;
};

export const useCaseStore = create<StoreState & Action>()(
  persist(
    set => ({
      ...initialState,
      setPreviewData: (key: string, data: PreviewCaseData) =>
        set(state => ({
          previewDataByKey: {
            ...state.previewDataByKey,
            [key]: data,
          },
        })),
      clearPreviewData: (key: string) =>
        set(state => {
          const { [key]: _, ...rest } = state.previewDataByKey;
          return { previewDataByKey: rest };
        }),
      clearAllPreviewData: () => set({ previewDataByKey: {} }),
      reset: () => set(initialState),
    }),
    {
      name: "case-store",
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
